<template>
  <div>
    <v-layout
      v-if="componentLoading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-layout
      v-else
      row
      wrap
    >
      <v-flex xs12>
        <v-card
          id="newInvite"
          class="max-shadow"
        >
          <v-toolbar
            :class="{ 'elevation-2': scrolled}"
            color="white"
            height="64"
            flat
          >
            <v-btn
              flat
              icon
              @click.stop="navigateBack"
            >
              <v-icon color="iconColor">
                arrow_back
              </v-icon>
            </v-btn>
            <v-toolbar-title class="blue-grey--text text--darken-3">
              Add Invite
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                color="primary"
                flat
                @click.stop="saveVisitorInvite"
              >
                save
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-layout
            column
          >
            <v-layout
              row
              wrap
            >
              <v-flex xs3>
                <v-layout
                  column
                  align-center
                  class="pa-4 ml-3"
                >
                  <avatar
                    :src="photoUri"
                    text="M"
                    :size="160"
                  />
                  <!-- <v-btn
                    color="primary"
                    flat
                    @click.stop="openFileDialog">upload photo</v-btn> -->
                </v-layout>
              </v-flex>
              <v-layout
                v-scroll:#newInviteForm="onScroll"
                column
              >
                <v-form
                  id="newInviteForm"
                  ref="form"
                  class="form"
                >
                  <div
                    class="fields px-5"
                  >
                    <div id="invitePhone">
                      <phone-field 
                        v-model="phone"
                        :loading="loading"
                        :disabled="phoneDisabled"
                        label="Visitor Phone"
                        default-country-code="IN"
                        required
                      />
                    </div>
                    <v-select
                      v-model="selectedVisitorType"
                      :items="visitorTypes"
                      :disabled="visitorTypeDisabled"
                      item-text="general.type_name"
                      return-object
                      label="Visitor Purpose"
                    />
                    <v-input
                      v-model="selectedDateTime"
                      :rules="[ (v) => !!v || 'Expected date and time is required']"
                      class="inviteDateTimePicker"
                    >
                      <template slot="default">
                        <date-time-picker
                          v-model="selectedDateTime"
                          :show-placeholder="true"
                          :min="minDateTime"
                          :allowed-minute-steps="5"
                          title="Expected At" 
                        />
                      </template>
                    </v-input>
                    <template v-if="selectedVisitorType.host_screen.host_selection">
                      <template v-if="!shouldDisableHostSelection">
                        <vizmo-autocomplete
                          v-model="selectedHost"
                          :items="employees"
                          :rules="[v => (!!v && !!v.id) || 'Host is required']"
                          label="Host"
                          placeholder="Type to search Employees" 
                        />
                      </template>
                      <template v-else>
                        <v-text-field
                          :value="selectedHost.name"
                          :disabled="true"
                          label="Host"
                        />
                      </template>
                    </template>
                    <template v-if="selectedVisitorType.checkin_fields">
                      <v-text-field
                        ref="full_name"
                        v-model="fullName"
                        type="text"
                        label="Full Name *"
                      />
                      <template v-if="selectedVisitorType.checkin_fields[1].hide === undefined || !selectedVisitorType.checkin_fields[1].hide">
                        <v-text-field
                          ref="email"
                          v-model="email"
                          label="Email Address"
                        />
                      </template>
                      <template v-if="selectedVisitorType.checkin_fields[2].hide === undefined || !selectedVisitorType.checkin_fields[2].hide">
                        <v-text-field
                          ref="company"
                          v-model="company"
                          label="Company"
                        />
                      </template>
                      <v-textarea
                        v-model="comments"
                        rows="3"
                        auto-grow
                        label="Comments"
                        persistent-hint
                        hint="Helps to convey the purpose of this invite" 
                      />
                      <div
                        v-for="(field, key) in visitorLogItem.fields"
                        :key="key"
                        class="pt-2"
                      >
                        <template v-if="field.type === 'text_field' && key ==='full_name' && key === 'email' && key === 'company'">
                          <v-text-field
                            :id="field.id"
                            v-model="field.value"
                            :label="field.label"
                            :rules="[
                              (v) => {return requiredCheck(v, field);}
                            ]"
                            :type="field.type"
                          />
                        </template>
                        <template v-if="field.type === 'single_choice'">
                          <p
                            class="subheading"
                            style="margin-bottom:0"
                          >
                            {{ field.label }} <span
                              v-if="field.required"
                              style="color: red"
                            >
                              *
                            </span>
                          </p>
                          <v-radio-group
                            :id="field.id"
                            v-model="field.value"
                            :rules="[
                              (v) => {return requiredCheck(v, field);}
                            ]"
                            style="margin-top:0"
                          >
                            <div
                              v-for="option in field.options"
                              :key="option.value"
                              class="pl-2"
                            >
                              <v-radio
                                :label="option.value"
                                :value="option.value"
                                :name="dashedString(option.value)"
                                color="primary"
                              />
                            </div>
                          </v-radio-group>
                        </template>
                        <template v-if="field.type === 'multi_choice'">
                          <p
                            class="subheading"
                            style="margin-bottom:0"
                          >
                            {{ field.label }} <span
                              v-if="field.required"
                              style="color: red"
                            >
                              *
                            </span>
                          </p>
                          <v-radio-group
                            v-model="field.value"
                            :rules="[
                              (v) => {return requiredCheck(v, field);}
                            ]"
                            style="margin-top:0"
                          >
                            <checkbox-group
                              v-model="field.value"
                              :options="field.options"
                              class="pl-2"
                            />
                          </v-radio-group>
                        </template>
                        <template v-if="field.type === 'dropdown'">
                          <v-select
                            :id="field.id"
                            v-model="field.value"
                            :items="field.options"
                            :label="field.label"
                            :rules="[
                              (v) => {return requiredCheck(v, field);}
                            ]"
                            item-text="value"
                          />
                        </template>
                      </div>
                    </template>
                  </div>
                </v-form>
              </v-layout>
            </v-layout>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';
import _omit from 'lodash/omit';
import { database } from '@/firebase';
import validationRules from '@/mixins/validation-rules';
import md5 from 'md5';
import * as moment from 'moment';

import Avatar from '@/components/common/Avatar';
import dateTimePicker from '@/components/common/DateTimePicker';
import checkboxGroup from '@/components/common/CheckboxGroup';
import vizmoAutoComplete from '@/components/common/VizmoAutoComplete';
import PhoneField from '@/components/common/PhoneField';

export default {
  name: 'NewInvite',
  components: {
    avatar: Avatar,
    'checkbox-group': checkboxGroup,
    'date-time-picker': dateTimePicker,
    'vizmo-autocomplete': vizmoAutoComplete,
    'phone-field': PhoneField
  },
  mixins: [validationRules],
  data() {
    return {
      phone: '',
      loading: false,
      visitorTypeDisabled: true,
      phoneDisabled: false,
      lastVisitorLogItem: {},
      visitorLogItem: {},
      visitorTypes: [],
      visitorTypeNames: [],
      employees: [],
      selectedVisitorType: {
        host_screen: {}
      },

      selectedDateTime: '',
      selectedDate: '',
      selectedTime: '',
      selectedHost: {},
      createdBy: {},
      minDateTime: null,

      search: null,

      fileName: '',
      photoSrc: '',

      fullName: '',
      email: '',
      company: '',
      comments: '',
      photoUri: '',
      fields: [],

      notificationCheckbox: false,
      componentLoading: true,

      scrolled: false,
      offsetTop: 0
    };
  },
  computed: {
    locationId() {
      return _get(this.$store.state.VMS, 'lid');
    },
    shouldDisableHostSelection() {
      const role = _get(this.$store.state.profile, 'role');
      return role === 'employee';
    }
  },
  watch: {
    locationId: {
      handler(val) {
        if (!val) return;
        this.fetchVisitorTypes();
        this.fetchEmployees();
      },
      immediate: true
    },
    offsetTop: {
      handler(val) {
        if (val > 20) {
          this.scrolled = true;
        } else {
          this.scrolled = false;
        }
      },
      immediate: true
    },
    selectedVisitorType: {
      handler(val) {
        if (!val) return;
        // console.log(val);
        this.selectedVisitorTypeChanged();
      }
    },
    selectedDateTime: {
      handler(val) {
        if (!val) return;
        this.selectedDate = moment(val).format('YYYY-MM-DD');
        this.selectedTime = moment(val).format('HH:mm');
      }
    },
    phone: {
      handler(val) {
        if (val.length === 10) {
          this.phoneChanged(val);
        }
      }
    }
  },
  created() {
    this.minDateTime = moment().format('YYYY-MM-DD HH:mm');
    // console.log(this.minTime);
  },
  methods: {
    navigateBack() {
      // TODO: check if the previous route is invites or not. we should always navigate back to invites
      this.$router.back();
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    fetchVisitorTypes() {
      const path = `vms/${this.locationId}/settings/checkin_flow`;
      database.ref(path).once('value', visitorTypeSnapshot => {
        if (!visitorTypeSnapshot) return;
        this.componentLoading = false;
        const visitorTypes = visitorTypeSnapshot.val();
        const visitorTypesArray = this._toArray(visitorTypes);
        const filteredVisitorTypesArrayByEnabled = visitorTypesArray.filter(
          o => o.general.enabled
        );
        this.visitorTypes = filteredVisitorTypesArrayByEnabled;
        // console.log(visitorTypes);
      });
    },
    fetchEmployees() {
      const path = `vms/${this.locationId}/employees`;
      database.ref(path).once('value', employeeSnapshot => {
        const employees = employeeSnapshot.val();
        const employeesArray = this._toArray(employees);
        this.employees = employeesArray;
      });
    },

    _toArray(obj) {
      if (!obj) return [];
      return Object.keys(obj).map(key => {
        const item = obj[key];
        item.id = key;
        return item;
      });
    },

    dashedString(str) {
      return str.replace(/\s+/g, '-').toLowerCase();
    },

    phoneChanged(val) {
      const phone = val;
      this.visitorTypeDisabled = false;
      this.phoneDisabled = true;
      this.loading = true;
      const visitorKey = md5(phone);
      this.fileName = visitorKey;
      if (this.$store.state.profile.role === 'employee') {
        database
          .ref(
            `/companies/${this.$store.state.profile.cid}/${
              this.locationId
            }/visitors/${visitorKey}`
          )
          .once('value')
          .then(snapshot => {
            this.phoneDisabled = false;
            this.loading = false;
            if (!snapshot.val()) return;
            const lastVistorDetails = snapshot.val();
            this.lastVisitorLogItem = lastVistorDetails;
            if (this.selectedVisitorType.general)
              this.visitorTypeSelected(this.selectedVisitorType);
          })
          .catch(() => {
            this.phoneDisabled = false;
            this.loading = false;
            this.lastVisitorLogItem = null;
          });
      } else {
        database
          .ref(`vms/${this.locationId}/visitors_data/${visitorKey}/visitor_log`)
          .limitToLast(1)
          .once('value')
          .then(snapshot => {
            this.phoneDisabled = false;
            this.loading = false;
            if (!snapshot.val()) return;
            const lastVisitorLogItem = Object.values(snapshot.val())[0];
            this.lastVisitorLogItem = lastVisitorLogItem;
            if (this.selectedVisitorType.general)
              this.visitorTypeSelected(this.selectedVisitorType);
            // console.log(lastVisitorLogItem);
          })
          .catch(() => {
            this.phoneDisabled = false;
            this.loading = false;
            this.lastVisitorLogItem = null;
          });
      }
    },

    selectedVisitorTypeChanged() {
      this.visitorLogItem.fields = {};
      // console.log(this.selectedVisitorType);
      this.selectedVisitorType.checkin_fields.forEach(field => {
        this.visitorLogItem.fields[field.id] = field;
      });
      this.visitorTypeSelected(_cloneDeep(this.selectedVisitorType));
      //
      // pull visitory types from firbease. convert to array of visitortypes. visitortypeid
      // val.key == lastvisitoritem.visitoryTypeKey ? currentvisitortitem = lastvisitoritem;
    },

    visitorTypeSelected(val) {
      const selectedVisitorType = val;
      const lastVisitorLogItem = _cloneDeep(this.lastVisitorLogItem);
      let host;
      if (this.$store.state.profile.role === 'employee') {
        const { profile } = this.$store.state;
        host = {
          name: profile.name,
          email: profile.email,
          phone: profile.phone || '',
          id: profile.uid
        };
        this.selectedHost = host;
      } else {
        const hostEmpArray = this.employees.filter(
          obj => obj.email === this.$store.state.profile.email
        )[0];
        host = hostEmpArray;
      }
      const defaultHost = _omit(host, 'account', 'designation');
      this.createdBy = defaultHost;
      // console.log(this.selectedHost);
      // console.log(lastVisitorLogItem, val);
      if (!lastVisitorLogItem) return;
      this.fullName = lastVisitorLogItem.name;
      this.email = lastVisitorLogItem.email;
      this.company = lastVisitorLogItem.company;
      this.photoUri = lastVisitorLogItem.photoUri;

      // TODO: why this? aren't you going to check if the host is null or not in lastVisitorLogItem?
      // due to this, i had to change some validation rules in auto complete
      if (
        selectedVisitorType.host_screen.host_selection &&
        this.$store.state.profile.role !== 'employee'
      ) {
        const selectedHost = {
          name: lastVisitorLogItem.hostName,
          email: lastVisitorLogItem.hostEmail,
          phone: lastVisitorLogItem.hostPhone,
          id: lastVisitorLogItem.hostUid
        };
        this.selectedHost = selectedHost;
      }

      if (val.id === lastVisitorLogItem.visitorTypeKey) {
        if (!lastVisitorLogItem.fields) return;
        Object.keys(lastVisitorLogItem.fields).forEach(fieldKey => {
          const field = this.visitorLogItem.fields[fieldKey];
          if (field) {
            field.value = lastVisitorLogItem.fields[fieldKey].value;
          }
        });
      }
    },

    requiredCheck(value, field) {
      if (field.required) {
        if (!value) return 'Field is required';
        return true;
      }
      return true;
    },

    getValidatedFields(fieldsObj) {
      const fields = _cloneDeep(fieldsObj);
      const removeableKeys = ['full_name', 'email', 'company'];
      // eslint-disable-next-line
      Object.entries(fields).forEach(([key, value]) => {
        // eslint-disable-next-line
        delete value.id;
        // eslint-disable-next-line
        value.value = value.value ? value.value.toString() : '';
      });
      const newFields = _omit(fields, removeableKeys);
      return newFields;
    },

    // openFileDialog() {
    //   this.$refs.photo.changePhoto();
    // },

    saveVisitorInvite() {
      if (this.$refs.form.validate()) {
        /* eslint-disable prefer-destructuring */
        const phone = this.phone;
        const date = this.selectedDate;
        const time = this.selectedTime;
        const expectedAt = moment(`${date} ${time}`).toISOString();
        const createdAt = moment().toISOString();
        const fullName = this.fullName;
        const email = this.email;
        const company = this.company;
        const comments = this.comments;
        const createdBy = {
          uid: this.createdBy.id,
          name: this.createdBy.name,
          email: this.createdBy.email,
          phone: this.createdBy.phone || '',
          department: this.createdBy.department || ''
        };
        const visitorInvite = {};
        const fields = this.getValidatedFields(this.visitorLogItem.fields);

        visitorInvite.fields = fields;
        visitorInvite.expectedAt = expectedAt;
        visitorInvite.name = fullName.trim();
        visitorInvite.phone = phone;
        visitorInvite.email = email.trim() || null;
        visitorInvite.company = company || null;
        visitorInvite.comments = comments || null;
        const hostSelection = this.selectedVisitorType.host_screen
          .host_selection;
        const host = hostSelection
          ? this.selectedHost
          : this.selectedVisitorType.host_screen.default_notification_receiver;
        if (host) {
          visitorInvite.host = {
            uid: host.id,
            name: host.name,
            email: host.email,
            phone: host.phone || '',
            department: host.department || ''
          };
        }
        visitorInvite.createdBy = createdBy;
        visitorInvite.createdAt = createdAt;
        visitorInvite.visitorType = this.selectedVisitorType.general.type_name;
        visitorInvite.visitorTypeKey = this.selectedVisitorType.id;
        visitorInvite.photoUri = this.photoUri || null;
        visitorInvite.used = false;

        // this.fileName = md5(visitorInvite.phone);
        // this.$refs.photo.upload().then((downloadURL) => {
        //   if (downloadURL || downloadURL === '') {
        //     visitorInvite.photoUri = downloadURL;
        //     console.log(visitorInvite);
        //     const visitorRef = firebase.database().ref(`${path}/visitors/${this.fileName}`);
        //     visitorRef.set(visitor);
        //   }
        // });
        const path = `vms/${this.locationId}`;
        const logRef = database.ref(`${path}/invites`).push();
        logRef.set(visitorInvite);
        this.navigateBack();
      }
    }
  }
};
</script>
<style>
#newInvite {
  height: calc(100vh - var(--toolbar-height));
}
#newInvite .form {
  height: calc(100vh - var(--form-height));
  overflow-y: scroll;
}
.v-text-field__prefix {
  width: 30px !important;
}
.inviteDateTimePicker {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>

